module.exports = {
  findAll: jest
    .fn()
    .mockResolvedValue([
      { address: { latitude: 1, longitude: 1 } },
      { address: { latitude: 2, longitude: 2 } }
    ])
};
